// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VP1a","icon":"styles_icon__287lk"};